// Languages
import en from './en/index.json'
import es from './es/index.json'
import hi from './hi/index.json'
import it from './it/index.json'
import th from './th/index.json'
import pt_br from './pt-br/index.json'

export default {
  en,
  es,
  hi,
  it,
  th,
  pt_br
}
